import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInviteUser = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 31,
	height: 22,
	viewBox: "0 0 31 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_2709_2265)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M7.5625 15.125V18.5625",
					stroke: "white",
					strokeWidth: 1.375,
					strokeLinejoin: "bevel"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M14.4375 15.1243V18.5618",
					stroke: "white",
					strokeWidth: 1.375,
					strokeLinejoin: "bevel"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M11 8.25C12.5188 8.25 13.75 7.01878 13.75 5.5C13.75 3.98122 12.5188 2.75 11 2.75C9.48122 2.75 8.25 3.98122 8.25 5.5C8.25 7.01878 9.48122 8.25 11 8.25Z",
					stroke: "white",
					strokeWidth: 1.375,
					strokeLinejoin: "bevel"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M4.8125 13.7503V18.5968L17.1875 18.5628V13.7503C17.1875 11.7226 15.7995 10.3128 13.75 10.3128H8.25C6.22229 10.3128 4.8125 11.7008 4.8125 13.7503Z",
					stroke: "white",
					strokeWidth: 1.375,
					strokeLinejoin: "bevel"
				})
			]
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 24.25,
			y: 6.5,
			width: 1.5,
			height: 9,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 29.5,
			y: 10.25,
			width: 1.5,
			height: 9,
			transform: "rotate(90 29.5 10.25)",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_2709_2265",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 22,
				height: 22,
				fill: "white"
			})
		}) })
	]
});
export default SvgInviteUser;
